import './App.css';
import Header from './components/Header'
import Footer from './components/Footer'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import AboutUs from './pages/AboutUs';
import LandingPage from './pages/LandingPage';
import Blog from './pages/Blog';
import BlogPost from './blogs/BlogPost';
import TalkToFoundersModal from './components/TalkToFounders';


function App() {
    return (
     <BrowserRouter>
      <Routes>
        <Route path="/" element={<><Header/><LandingPage/><Footer/></>} />
        <Route path="/about" element={<><Header/><AboutUs/><Footer/></>} />
        <Route path="/blog" element={<><Header/><Blog/><Footer/></>} />
        <Route path="/blog/:slug" element={<><Header/><BlogPost/><Footer/></>} />
        <Route path="/contactUs" element={<><Header/><TalkToFoundersModal/><Footer/></>} />
      </Routes>
    </BrowserRouter>
     );
}

export default App;